/**
 * Stable keys for the mutations that act on one task (spec 125 research R3).
 *
 * Keyed so `usePendingTaskActions` can read, from anywhere, which tasks have a
 * request in flight — a Stop pressed in a card's menu must show on the card
 * and in the drawer, and a menu's own `isPending` closes with the menu.
 */
export const TASK_MUTATION_KEYS = {
  move: ['tasks', 'move'],
  stop: ['tasks', 'stop'],
  rerun: ['tasks', 'rerun'],
  hide: ['tasks', 'hide'],
  delete: ['tasks', 'delete'],
  split: ['tasks', 'split'],
  /** Start all of a parent's waiting created tasks (spec 140 US2). */
  startChildren: ['tasks', 'start-children'],
} as const;
